import { Theme } from '@mui/material'

const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8

export const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
}

export const tags = [
  'elevator',
  'garage',
  'parking',
  'balcony',
  'fireplace',
  'garden',
  'pool',
  'air_conditioning',
  'furnished',
  'pet_friendly',
  'utilities_included',
  'laundry',
  'dishwasher',
  'security_system',
  'internet',
  'wheelchair_accessible',
  'storage',
  'fitness_center',
  'meeting_rooms',
  'reception_services',
];


export function postGetStyles(
  name: string,
  personName: readonly string[],
  theme: Theme,
) {
  return {
    fontWeight:
      personName.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  }
}

export const category = ['A', 'B', 'C', 'D']

export const countryOptions = [
  { value: 0, label: 'Switzerland' },
  { value: 1, label: 'Poland' },
]

export const currencyValue = [
  { value: 0, label: 'CHF', name: 'CHF' },
  { value: 1, label: 'EUR', name: 'EUR' },
  { value: 2, label: 'USD', name: 'USD' },
]

export function formatCurrency(cents: any) {
  const chf = cents / 100
  return chf.toLocaleString('en-EU', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
}
export function formatCurrencyWithoutCents(cents: any) {
  const chf = cents / 100
  return chf.toLocaleString('en-EU', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  })
}

export const genders = [
  { value: 0, label: 'Male' },
  { value: 1, label: 'Female' },
  { value: 2, label: 'Other' },
]
